import * as url from '../../helpers/url_helper';
import { get, post } from '../../helpers/api_helper';

export const getarrivalanddepartureDataAPI = () => {
	return get(url.GET_ARRIVAL_AND_DEPARTURE_DATA);
};

export const getLoadingBookingsDataAPI = inputDate => {
	return post(url.GET_TODAYS_LOADING_BOOKINGS_DATA, inputDate);
};

export const getTotalShipmentCountBasedOnYearAPI = data => {
	return post(url.GET_TOTAL_SHIPMENT_COUNT_BASED_ON_YEAR, data);
};

export const getTotalShipmentCountBasedOnCurrentMonthAPI = data => {
	return post(url.GET_TOTAL_SHIPMENT_COUNT_BASED_ON_CURRENT_MONTH, data);
};

export const getChartDataBasedOnContainerOrBookingsAPI = ({ year, chartType }) => {
	return post(url.GET_NO_OF_BOOKING_OR_CONTAINER_CHARTS_DATA, { year, chartType });
};

export const getChartDataBasedOnSupplierLocationAPI = data => {
	return post(url.GET_BOOKING_CHART_DATA_BASED_ON_SUPPLIER_LOCATION, data);
};

export const getContainerCountsBasedOnBookingStatusAPI = data => {
	return post(url.GET_CONTAINER_COUNTS_BASED_ON_BOOKING_STATUS, data);
};

export const getAdvancedBookingCountDataAPI = () => {
	return get(url.GET_ADVANCED_BOOKING_COUNT_DATA);
};

export const getAdvancedBookingDetailsAPI = () => {
	return get(url.GET_ADVANCED_BOOKING_DETAILS);
};

export const getChartDataBasedOnCustomersAPI = data => {
	return post(url.GET_CHART_DATA_BASED_ON_CUSTOMER, data);
};

export const getChartDataBasedOnCountryAPI = data => {
	return post(url.GET_CHART_DATA_BASED_ON_COUNTRY, data);
};

export const getChartDataBasedOnShippingLineAPI = data => {
	return post(url.GET_CHART_DATA_BASED_ON_SHIPPING_LINE, data);
};
